document.addEventListener('DOMContentLoaded', function () {
  const menuToggle = document.getElementById('menu-toggle');
  const menuClose = document.getElementById('menu-close');
  const mobileMenu = document.getElementById('mobile-menu');
console.log('mobine menu');
  menuToggle.addEventListener('click', function () {
	console.log('getting the click');
    mobileMenu.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  });

  menuClose.addEventListener('click', function () {
    mobileMenu.style.display = 'none';
    document.body.style.overflow = '';
  });
});
